import {getBuildFields} from '../../../rest/builds'
import type {GetBuildApiArg} from '../../../services/rest'
import type {BuildId} from '../../../types'
import {stringifyId} from '../../../types'

const artifactDependencyChangesFields = `artifactDependencyChanges(buildChange($locator(count:100),nextBuild(${getBuildFields()})))`

export const getBuildArtifactDependenciesChangesArg = (buildId: BuildId): GetBuildApiArg => ({
  buildLocator: `id:${stringifyId(buildId)}`,
  fields: artifactDependencyChangesFields,
})
